import { createTheme, alpha } from '@mui/material/styles';
import { colorSchemes, typography, shadows, shape } from './themePrimitives';
import { surfacesCustomizations } from './customizations/surfaces';
import { tablesCustomizations } from './customizations/tables';

const adminTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
    cssVarPrefix: 'template',
  },
  colorSchemes,
  typography,
  shadows,
  shape,
  components: {
    ...surfacesCustomizations,
    ...tablesCustomizations,
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: ({ theme }) => ({
          backgroundColor: (theme.vars || theme).palette.background.default,
          borderRight: `1px solid ${(theme.vars || theme).palette.divider}`,
        }),
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => {
          const selectedBg = theme.vars
            ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.12)`
            : alpha(theme.palette.primary.main, 0.12);
          const selectedHoverBg = theme.vars
            ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.18)`
            : alpha(theme.palette.primary.main, 0.18);
          return {
            borderRadius: (theme.vars || theme).shape.borderRadius,
            margin: '2px 8px',
            padding: '6px 12px',
            '&.Mui-selected': {
              backgroundColor: selectedBg,
              '&:hover': {
                backgroundColor: selectedHoverBg,
              },
            },
          };
        },
      },
    },
  },
});

export default adminTheme;
